<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <img src="static/img/avatars/default.png" class="img-avatar" alt="">
          <label style="margin-right:30px">
            {{ $store.getters.accountData.firstName + ' ' + $store.getters.accountData.lastName }}
          </label>
        </template>
        <b-dropdown-header tag="div" class="text-center"><strong><i class="fa fa-building-o" aria-hidden="true"></i>&nbsp;&nbsp;{{$store.getters.accountData.account.name}}</strong></b-dropdown-header>
        <b-dropdown-item href="#/profile"><i class="fa fa-user"></i> Profile</b-dropdown-item>
        <!-- <b-dropdown-divider></b-dropdown-divider> -->
        <b-dropdown-item href="#/logout">
          <i class="fa fa-sign-out"></i> Logout
        </b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
  export default {
    name: 'header-dropdown'
  }
</script>



// WEBPACK FOOTER //
// src/components/HeaderDropdown.vue